import { render, staticRenderFns } from "./EventTypeComponent.vue?vue&type=template&id=19d8a733&scoped=true&"
import script from "./EventTypeComponent.vue?vue&type=script&lang=js&"
export * from "./EventTypeComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19d8a733",
  null
  
)

export default component.exports